module.exports = __webpack_public_path__ + "static/media/Cairo-Bold.3a2bbac5.woff";